<ng-template #matPrefix>
  @if (to.addonLeft && addonLeftVisible && !to.addonLeft.hide) {
    <span [ngStyle]="{ cursor: to.addonLeft.onClick ? 'pointer' : 'inherit' }" (click)="addonLeftClick($event)">
      @if (to.addonLeft.svgIcon) {
        <mat-icon
          [svgIcon]="to.addonLeft.svgIcon"
          [matTooltip]="to.addonLeft.tooltip | translate"
          [matTooltipPosition]="'before'"
        ></mat-icon>
      }
      @if (to.addonLeft.icon) {
        <mat-icon [matTooltip]="to.addonLeft.tooltip | translate" [matTooltipPosition]="'before'">{{ to.addonLeft.icon }}</mat-icon>
      }
      @if (to.addonLeft.text) {
        <span matTextPrefix>{{ to.addonLeft.text }}</span>
      }
    </span>
  }
</ng-template>

<ng-container #fieldComponent></ng-container>

<ng-template #matSuffix>
  @if (to.addonRight && addonRightVisible && !to.addonRight.hide) {
    <span [ngStyle]="{ cursor: to.addonRight.onClick ? 'pointer' : 'inherit' }" (click)="addonRightClick($event)">
      @if (to.addonRight.svgIcon) {
        <mat-icon
          [svgIcon]="to.addonRight.svgIcon"
          [matTooltip]="to.addonRight.tooltip | translate"
          [matTooltipPosition]="'after'"
        ></mat-icon>
      }
      @if (to.addonRight.icon) {
        <mat-icon [matTooltip]="to.addonRight.tooltip | translate" [matTooltipPosition]="'after'">{{ to.addonRight.icon }}</mat-icon>
      }
      @if (to.addonRight.text) {
        <span matTextSuffix>{{ to.addonRight.text }}</span>
      }
    </span>
  }
</ng-template>
